module.exports = __webpack_public_path__ + "static/media/course_2-alt-photo.2e340926.png";